import { memo, useEffect, useState } from "react";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import ModalFooter from "ui/components/Modal/ModalFooter";
import { Button } from "ui/components/Button/Button";
import { NumberField } from "ui/components/TextField/NumberField";
import { CheckBox } from "ui/components/CheckBox";

interface Props {
  show: boolean;
  channelName: string | null;
  initialValue: number | null;
  onSave: (value: number | null, applyToAll: boolean) => void;
  onClose: () => void;
}

// Modal za prilagodbu cijene jednog kanala s opcijom "Primijeni na sve
// oglasnike" — ako je checkbox uključen, ista vrijednost se zapiše u sve
// odabrane kanale (vidi handleModalSave u PriceStep-u).
const PriceAdjustModal: React.FC<Props> = ({ show, channelName, initialValue, onSave, onClose }) => {
  const [value, setValue] = useState<number | null>(initialValue);
  // Cijena se u pravilu izjednačava po svim oglasnicima, pa je uključeno po defaultu.
  const [applyToAll, setApplyToAll] = useState(true);

  // Resetiramo lokalni state svaki put kad se modal otvori za drugi kanal —
  // inače bi se prethodna vrijednost zadržala.
  useEffect(() => {
    if (show) {
      setValue(initialValue);
      setApplyToAll(true);
    }
  }, [show, initialValue]);

  const handleSave = () => {
    onSave(value, applyToAll);
  };

  return (
    <Modal show={show} onHide={onClose} size="small" position="centered">
      <ModalHeader
        title={channelName ? `Prilagodi cijenu — ${channelName}` : "Prilagodi cijenu"}
        icon="/media/images/add-icon.svg"
        onHide={onClose}
      />
      <ModalBody>
        <div className="px-4 py-5 flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Cijena</label>
            <NumberField
              name="adjustedPrice"
              placeholder="0,00"
              decimals={2}
              value={value}
              onChange={(v) => setValue(v)}
              groupAppend="€"
            />
          </div>

          <CheckBox
            name="applyToAll"
            checked={applyToAll}
            onChange={(_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => setApplyToAll(checked)}
            label="Primijeni na sve oglasnike"
          />
        </div>
      </ModalBody>
      <ModalFooter>
           <div className="px-4 py-3 fixed left-0 bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end gap-3">
          <Button variant="outlined" onClick={onClose}>
            Odustani
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Spremi
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default memo(PriceAdjustModal);
